import { render, staticRenderFns } from "./memberDatum.vue?vue&type=template&id=a550bf16&scoped=true&"
import script from "./memberDatum.vue?vue&type=script&lang=js&"
export * from "./memberDatum.vue?vue&type=script&lang=js&"
import style0 from "./memberDatum.vue?vue&type=style&index=0&id=a550bf16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a550bf16",
  null
  
)

export default component.exports